import React from 'react';
import { ProceedButtonProps } from './types';
import { ArcButton } from '@src/core/ui';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setSelectedOrder, setOrderFormData } from '@src/features/order/pages/orders-page/redux';
import { routesConfig } from '@src/core/routes';

const ProceedButton: React.FC<ProceedButtonProps> = (props) => {
  const { order } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onProceed = () => {
    if (order) {
      dispatch(setOrderFormData(order));
    }
    
    navigate(`${routesConfig.orders}/create-mission/${order.id}`);
    dispatch(setSelectedOrder(null));
  };

  return (
    <ArcButton.brand 
      fullWidth 
      onClick={onProceed}> 
      Proceed
    </ArcButton.brand>
  );
};

export default ProceedButton;